import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        cardmachinearr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_CARDMACHINELIST: (state, obj) => {

            state.total = obj.total
            state.cardmachinearr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.cardmachinearr.splice(index,1)
        },
        CLEAR_CARDMACHINELIST: (state) => {

            state.total = 0
            state.cardmachinearr=[]

        },


    },
    actions: {
        async getCardmachinelist({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getcardmachinelist(params)
            if (code == 200) {
                commit('SET_CARDMACHINELIST', data);
           
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}